import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7420428d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-pay" }

import { ref, watch, computed } from "vue";
import { isGotoLogin } from "@/utils/index";
import { ElMessage } from "element-plus";
import { getPrice } from "@/api/pay";
import Pay from "./Pay.vue";
import store from "@/store";
import router from "@/router";
import { useRoute } from "vue-router";
import i18n from "@/lang";

export default /*#__PURE__*/_defineComponent({
  __name: 'MobilePay',
  setup(__props) {

const isMobile = store.state.isMobile;

const $t = i18n.global.t;
const payVisible = ref(true);
const priceList = ref([]);
const productId = ref(0);
const gotoPurchase = (id: number) => {
  if (!isGotoLogin()) {
    productId.value = id;
    let arr = [0, 1794, 3588];
    getPrice({
      calcType: 1,
      currencyType: "CNY",
      productId: id,
    }).then((res: any) => {
      if (res.code == 0) {
        let oData = res.data.productPriceList;
        oData.map((item: any, index: number) => {
          item.lodPrice = arr[index];
        });
        priceList.value = oData;
        store.commit("pay/setPageList", oData);
      }
    });
  }
};
gotoPurchase(2);
const route = useRoute();
const toPath =
  route.query.back_path && route.query.back_path === "personal"
    ? "/userCenter/personal"
    : "/privilege";
if (route.params.errorCode) {
  ElMessage.error($t("privilege.pay_error"));
}
watch(
  () => store.state.appLanguage,
  () => {
    gotoPurchase(2);
  }
);

return (_ctx: any,_cache: any) => {
  const _component_SecondPageHeader = _resolveComponent("SecondPageHeader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(_component_SecondPageHeader, {
          key: 0,
          title: _unref($t)('information.searchType.recharge'),
          toPath: _unref(toPath)
        }, null, 8, ["title", "toPath"]))
      : _createCommentVNode("", true),
    _createVNode(Pay, {
      visible: payVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((payVisible).value = $event)),
      priceList: priceList.value,
      productId: productId.value
    }, null, 8, ["visible", "priceList", "productId"])
  ]))
}
}

})